import React, { useEffect } from "react";
import deleteIcon from "../../../assets/images/calender.png";
import arrowIcon from "../../../assets/images/arrow.png";
import meetingChannel from "../../../assets/images/meeting_channel.png";

const SubmitBookEvent = ({ eventData }) => {
  useEffect(() => {
    console.log(eventData);
  });
  return (
    <section className="confirmation">
      <div className="confirmation__bottom-shape"></div>
      <div className="card">
        <div className="flex">
          <img
            className="confirmation__calender"
            src={deleteIcon}
            alt="delete"
          />

          <div className="card-title ml-4">
            Confirmation page
            <p>Confirmation page , Active links</p>
          </div>
        </div>
        <div className="confirmation__copy-link flex">
          <div className="form-control">
            {" "}
            <span> http://meeting url link here </span>
            <button className="ml-auto hover:text-black-dark">
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M8 16c0 1.886 0 2.828.586 3.414C9.172 20 10.114 20 12 20h4c1.886 0 2.828 0 3.414-.586C20 18.828 20 17.886 20 16v-4c0-1.886 0-2.828-.586-3.414C18.828 8 17.886 8 16 8m-8 8h4c1.886 0 2.828 0 3.414-.586C16 14.828 16 13.886 16 12V8m-8 8c-1.886 0-2.828 0-3.414-.586C4 14.828 4 13.886 4 12V8c0-1.886 0-2.828.586-3.414C5.172 4 6.114 4 8 4h4c1.886 0 2.828 0 3.414.586C16 5.172 16 6.114 16 8"></path>
              </svg>
            </button>
          </div>
          <button className="btn btn-dark">
            <img src={arrowIcon} alt="arrow-icon" />
            /home/rl8/Downloads/arrow-drop-down.svg
          </button>
        </div>
        <div className="text-xl mb-6 font-bold">Daily meeting</div>
        <p className="mb-1">Alex costa</p>
        <p>
          <span className="text-gray-spanish">on</span> Google Meeting
        </p>
        <ul className="confirmation__list">
          <li>
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_98:3)">
                <path
                  d="M42.1667 4.31297H35.9375V1.43797C35.9378 1.05672 35.7865 0.690987 35.5171 0.421224C35.2477 0.15146 34.8822 -0.000233774 34.501 -0.00048794C34.1197 -0.000742106 33.754 0.150465 33.4842 0.419868C33.2144 0.689272 33.0628 1.0548 33.0625 1.43605V4.31297H24.4375V1.43797C24.4376 1.2492 24.4006 1.06224 24.3284 0.88779C24.2563 0.713336 24.1505 0.554797 24.0171 0.421224C23.8837 0.28765 23.7253 0.181659 23.551 0.109302C23.3766 0.0369445 23.1897 -0.000362111 23.001 -0.000487961C22.6197 -0.000742127 22.254 0.150465 21.9842 0.419868C21.7144 0.689272 21.5628 1.0548 21.5625 1.43605V4.31297H12.9375V1.43797C12.9376 1.2492 12.9006 1.06224 12.8284 0.88779C12.7563 0.713336 12.6505 0.554797 12.5171 0.421224C12.3837 0.28765 12.2254 0.181659 12.051 0.109302C11.8766 0.0369445 11.6897 -0.000362111 11.501 -0.000487961C11.1197 -0.000742127 10.754 0.150465 10.4842 0.419868C10.2144 0.689272 10.0628 1.0548 10.0625 1.43605V4.31297H3.83333C2.817 4.31297 1.84227 4.71657 1.12343 5.43505C0.4046 6.15352 0.000508166 7.12806 0 8.14439V42.1652C0 43.1819 0.403868 44.1569 1.12276 44.8758C1.84165 45.5947 2.81667 45.9986 3.83333 45.9986H42.1667C43.1833 45.9986 44.1584 45.5947 44.8772 44.8758C45.5961 44.1569 46 43.1819 46 42.1652V8.14439C45.9995 7.12806 45.5954 6.15352 44.8766 5.43505C44.1577 4.71657 43.183 4.31297 42.1667 4.31297ZM43.125 42.1671C43.125 42.421 43.0243 42.6644 42.845 42.8441C42.6657 43.0238 42.4224 43.125 42.1686 43.1255H3.83333C3.57917 43.1255 3.33541 43.0245 3.15569 42.8448C2.97597 42.6651 2.875 42.4213 2.875 42.1671V8.1463C2.87551 7.89247 2.9767 7.64921 3.15637 7.4699C3.33603 7.29059 3.5795 7.18989 3.83333 7.18989H10.0625V10.0649C10.0622 10.4461 10.2135 10.8119 10.4829 11.0816C10.7523 11.3514 11.1178 11.5031 11.499 11.5033C11.8803 11.5036 12.246 11.3524 12.5158 11.083C12.7856 10.8136 12.9372 10.4481 12.9375 10.0668V7.18989H21.5625V10.0649C21.5622 10.4461 21.7135 10.8119 21.9829 11.0816C22.2523 11.3514 22.6178 11.5031 22.999 11.5033C23.3803 11.5036 23.746 11.3524 24.0158 11.083C24.2856 10.8136 24.4372 10.4481 24.4375 10.0668V7.18989H33.0625V10.0649C33.0622 10.4461 33.2135 10.8119 33.4829 11.0816C33.7523 11.3514 34.1178 11.5031 34.499 11.5033C34.8803 11.5036 35.246 11.3524 35.5158 11.083C35.7855 10.8136 35.9372 10.4481 35.9375 10.0668V7.18989H42.1667C42.4202 7.19039 42.6631 7.29132 42.8424 7.47057C43.0216 7.64983 43.1226 7.8928 43.1231 8.1463L43.125 42.1671Z"
                  fill="#27273D"
                />
                <path
                  d="M10.0625 17.25H15.8125V21.5625H10.0625V17.25Z"
                  fill="#27273D"
                />
                <path
                  d="M10.0625 24.4375H15.8125V28.75H10.0625V24.4375Z"
                  fill="#27273D"
                />
                <path
                  d="M10.0625 31.625H15.8125V35.9375H10.0625V31.625Z"
                  fill="#27273D"
                />
                <path
                  d="M20.125 31.625H25.875V35.9375H20.125V31.625Z"
                  fill="#27273D"
                />
                <path
                  d="M20.125 24.4375H25.875V28.75H20.125V24.4375Z"
                  fill="#27273D"
                />
                <path
                  d="M20.125 17.25H25.875V21.5625H20.125V17.25Z"
                  fill="#27273D"
                />
                <path
                  d="M30.1875 31.625H35.9375V35.9375H30.1875V31.625Z"
                  fill="#27273D"
                />
                <path
                  d="M30.1875 24.4375H35.9375V28.75H30.1875V24.4375Z"
                  fill="#27273D"
                />
                <path
                  d="M30.1875 17.25H35.9375V21.5625H30.1875V17.25Z"
                  fill="#27273D"
                />
              </g>
              <defs>
                <clipPath id="clip0_98:3">
                  <rect width="46" height="46" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="sm:flex sm:gap-5">
              <p>Tuesday to Saturday </p>
              <p>19-oct-2021 to 23-oct-2021 </p>
            </div>
          </li>
          <li>
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23 46C18.451 46 14.0042 44.6511 10.2219 42.1238C6.43956 39.5965 3.4916 36.0044 1.75078 31.8017C0.00996551 27.599 -0.445511 22.9745 0.441949 18.5129C1.32941 14.0514 3.51994 9.95316 6.73655 6.73655C9.95316 3.51994 14.0514 1.32941 18.5129 0.441949C22.9745 -0.445511 27.599 0.00996551 31.8017 1.75078C36.0044 3.4916 39.5965 6.43956 42.1238 10.2219C44.6511 14.0042 46 18.451 46 23C46 29.1 43.5768 34.9501 39.2634 39.2634C34.9501 43.5768 29.1 46 23 46ZM23 3.28572C19.1009 3.28572 15.2893 4.44195 12.0473 6.60818C8.80534 8.77441 6.27851 11.8534 4.78638 15.4557C3.29426 19.058 2.90385 23.0219 3.66453 26.8461C4.42521 30.6703 6.30281 34.183 9.0599 36.9401C11.817 39.6972 15.3297 41.5748 19.1539 42.3355C22.9781 43.0962 26.942 42.7057 30.5443 41.2136C34.1466 39.7215 37.2256 37.1947 39.3918 33.9527C41.5581 30.7107 42.7143 26.8991 42.7143 23C42.7143 17.7715 40.6372 12.757 36.9401 9.0599C33.243 5.36276 28.2286 3.28572 23 3.28572Z"
                fill="#27273D"
              />
              <path
                d="M30.5407 32.8572L21.3572 23.6736V8.21436H24.6429V22.3101L32.8572 30.5408L30.5407 32.8572Z"
                fill="#27273D"
              />
            </svg>

            <p>45 min | 12:00pm - 12:45pm </p>
          </li>
          <li className="items-start">
            <svg
              width="38"
              height="51"
              viewBox="0 0 38 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.9429 11.6572C17.502 11.6572 16.0933 12.0845 14.8952 12.8851C13.6971 13.6857 12.7633 14.8235 12.2118 16.1548C11.6604 17.4861 11.5161 18.951 11.7972 20.3643C12.0783 21.7776 12.7722 23.0758 13.7912 24.0947C14.8101 25.1136 16.1083 25.8075 17.5216 26.0887C18.9349 26.3698 20.3998 26.2255 21.7311 25.6741C23.0624 25.1226 24.2002 24.1888 25.0008 22.9907C25.8014 21.7925 26.2287 20.3839 26.2287 18.9429C26.2265 17.0113 25.4581 15.1595 24.0923 13.7936C22.7264 12.4277 20.8746 11.6594 18.9429 11.6572ZM18.9429 22.5858C18.2225 22.5858 17.5181 22.3721 16.9191 21.9719C16.32 21.5716 15.8531 21.0026 15.5774 20.337C15.3017 19.6714 15.2295 18.9389 15.3701 18.2323C15.5106 17.5256 15.8576 16.8765 16.3671 16.3671C16.8765 15.8576 17.5256 15.5106 18.2323 15.3701C18.9389 15.2295 19.6714 15.3017 20.337 15.5774C21.0026 15.8531 21.5716 16.32 21.9719 16.9191C22.3721 17.5181 22.5858 18.2224 22.5858 18.9429C22.5847 19.9087 22.2005 20.8347 21.5176 21.5176C20.8347 22.2005 19.9087 22.5847 18.9429 22.5858Z"
                fill="#27273D"
              />
              <path
                d="M32.3373 5.55071C29.0253 2.23723 24.6042 0.268895 19.9273 0.0255834C15.2503 -0.217728 10.6491 1.28124 7.01161 4.23318C3.37414 7.18512 0.958284 11.3808 0.230312 16.0104C-0.49766 20.6399 0.513855 25.3753 3.06964 29.3024L16.2389 49.5338C16.532 49.984 16.9327 50.3538 17.4047 50.6099C17.8767 50.8659 18.4051 51 18.942 51C19.479 51 20.0074 50.8659 20.4794 50.6099C20.9514 50.3538 21.3521 49.984 21.6452 49.5338L34.8149 29.3024C37.1864 25.6594 38.2344 21.3114 37.7833 16.9871C37.3322 12.6628 35.4095 8.62507 32.3373 5.55071ZM31.8945 27.3986L18.9421 47.2961L5.98958 27.3986C2.02487 21.3079 2.87521 13.1571 8.01148 8.01699C9.44689 6.58053 11.151 5.44106 13.0265 4.66364C14.902 3.88623 16.9121 3.4861 18.9421 3.4861C20.9721 3.4861 22.9823 3.88623 24.8577 4.66364C26.7332 5.44106 28.4373 6.58053 29.8727 8.01699C35.009 13.1571 35.8592 21.3079 31.8945 27.3986Z"
                fill="#27273D"
              />
            </svg>

            <div>
              <p>Google meeting</p>
              <div className="text-xs text-gray-taupe flex mt-2 items-center">
                Join with Google meeting channel{" "}
                <a onClick={(e) => e.preventDefault()} href="/#">
                  <img
                    className="location-icon ml-3"
                    src={meetingChannel}
                    alt="meeting-channel-icon"
                  />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default SubmitBookEvent;
